module.exports = __webpack_public_path__ + "img/Squiggles.db7af81d.png";